var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h1',{staticClass:"text-center"},[_vm._v("Campaign Management")]),_c('p',{staticClass:"text-center text-muted"},[_vm._v(" Manage referral campaigns and rewards ")]),_c('div',[_c('ListReferralCampaign')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }